/**
 * Mulberry32 – fast deterministic PRNG seeded with a 32-bit integer.
 * Used for piece generation and garbage placement so both client and server
 * stay in sync given the same seed.
 */
export class RNG {
  private state: number

  constructor(seed: number) {
    this.state = seed >>> 0
  }

  /** Returns a pseudo-random unsigned 32-bit integer. */
  next(): number {
    let t = (this.state += 0x6d2b79f5)
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0)
  }

  /** Returns a float in [0, 1). */
  nextFloat(): number {
    return this.next() / 0x100000000
  }

  /** Returns an integer in [0, n). */
  nextInt(n: number): number {
    return this.next() % n
  }

  /** Fisher-Yates shuffle on a copy of the array. */
  shuffle<T>(arr: T[]): T[] {
    const out = arr.slice()
    for (let i = out.length - 1; i > 0; i--) {
      const j = this.nextInt(i + 1)
      ;[out[i], out[j]] = [out[j], out[i]]
    }
    return out
  }
}
